// ========== Display Selected Variant images in 1 row 1 column ==========

// document.addEventListener('DOMContentLoaded', function () {
//     const variantInput = document.querySelector('input[name="id"]');
//     const variantsJson = document.getElementById('product-variants-json');
//     let skus;

//     if (variantsJson) {
//       const variants = JSON.parse(variantsJson.textContent);
//       skus = variants.map(v => v.sku ? v.sku.trim().toLowerCase() : []);
//     }

//     function updateColorImage() {
//       const mediaElements = document.querySelectorAll('[data-media-alt]');
//       const sku_element = document.querySelector('.product__sku');
//       const sku_info = Array.from(sku_element.childNodes)
//       .filter(node => node.nodeType === Node.TEXT_NODE)
//       .map(node => node.textContent.trim())
//       .join(' ')
//       .trim().toLowerCase();
//       const isSkuMatch = skus.includes(sku_info);

//       /*
//       console.log("SKU Info:", sku_info);
//       console.log("SKUs:", skus);
//       console.log("Is SKU Match:", isSkuMatch);
//       */
      
//       if (mediaElements && mediaElements.length > 0) {

//         const matchExists = Array.from(mediaElements).some(el => {
//           const altColor = el.getAttribute('data-media-alt').trim().toLowerCase();
//           return altColor.includes(sku_info);
//         });
        
//         if (isSkuMatch && matchExists) {
//           mediaElements.forEach((el) => {        
//             const altColor = el.getAttribute('data-media-alt').trim().toLowerCase();
//             const isMatch = altColor.includes(sku_info);        
//               if (isMatch) {
//                 el.classList.remove('hidden');
//               }else {
//                 el.classList.add('hidden');
//               }
//           });
          
//         }
//         else {
//             if (isSkuMatch) {
//             mediaElements.forEach((el) => {       
//               const altColor = el.getAttribute('data-media-alt').trim().toLowerCase(); 
//               const getPrdTitleEle = document.querySelector('.product__title');
//               const getPrdTitle = getPrdTitleEle.getAttribute('data-product-title').toLowerCase();
//               console.log(altColor);
//               if (altColor.includes(getPrdTitle)) {     
//               el.classList.remove('hidden');   
//               }else {
//                 el.classList.add('hidden'); 
//               } 
//             });
//           }
//         }
//       }
//     }

//     updateColorImage();

//     const observer = new MutationObserver((mutationsList) => {
//       // console.log("Mutation observed:", mutationsList);
//       updateColorImage();
//     });

//     observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
//   });
  


// ========== Display Selected Variants all Images First ==========

// ============================================================
// D2D SELECT VARIANT GALLERY
// SELECTED METAL IMAGES FIRST
// WITH MEDIA GALLERY BLINK FIX
// ============================================================

document.addEventListener(
  'DOMContentLoaded',
  function () {

    const variantInput =
      document.querySelector(
        'input[name="id"]'
      );

    const variantsJson =
      document.getElementById(
        'product-variants-json'
      );


    if (
      !variantInput ||
      !variantsJson
    ) {

      console.log(
        '[D2D Gallery] Required elements not found'
      );

      return;

    }


    // ========================================================
    // VARIANTS
    // ========================================================

    let variants = [];


    try {

      variants =
        JSON.parse(
          variantsJson.textContent
        );

    } catch (error) {

      console.error(
        '[D2D Gallery] Variant JSON error:',
        error
      );

      return;

    }


    // ========================================================
    // NORMALIZE
    // ========================================================

    function normalize(
      value
    ) {

      return String(
        value || ''
      )
        .toLowerCase()
        .replace(
          /[_\-\/]+/g,
          ' '
        )
        .replace(
          /\s+/g,
          ' '
        )
        .trim();

    }


    // ========================================================
    // GET SELECTED VARIANT
    // ========================================================

    function getSelectedVariant() {

      const selectedId =
        String(
          variantInput.value || ''
        );


      return variants.find(
        function (variant) {

          return (
            String(variant.id) ===
            selectedId
          );

        }
      );

    }


    // ========================================================
    // GET SELECTED METAL
    // ========================================================

    function getSelectedMetal(
      variant
    ) {

      const options = [

        variant.option1,
        variant.option2,
        variant.option3

      ];


      for (
        const option of options
      ) {

        const value =
          normalize(
            option
          );


        // ====================================================
        // WHITE GOLD
        // ====================================================

        if (
          value.includes(
            'white gold'
          ) ||
          value === 'white'
        ) {

          return 'white';

        }


        // ====================================================
        // YELLOW GOLD
        // ====================================================

        if (
          value.includes(
            'yellow gold'
          ) ||
          value === 'yellow'
        ) {

          return 'yellow';

        }


        // ====================================================
        // ROSE GOLD
        // ====================================================

        if (
          value.includes(
            'rose gold'
          ) ||
          value === 'rose'
        ) {

          return 'rose';

        }


        // ====================================================
        // SILVER
        // ====================================================

        if (
          value.includes(
            'sterling silver'
          ) ||
          value.includes(
            'silver'
          ) ||
          value.includes(
            's 925'
          ) ||
          value.includes(
            's925'
          ) ||
          value.includes(
            '925'
          )
        ) {

          return 'silver';

        }

      }


      // ======================================================
      // FALLBACK - VARIANT TITLE
      // ======================================================

      const title =
        normalize(
          variant.title
        );


      if (
        title.includes(
          'white gold'
        )
      ) {

        return 'white';

      }


      if (
        title.includes(
          'yellow gold'
        )
      ) {

        return 'yellow';

      }


      if (
        title.includes(
          'rose gold'
        )
      ) {

        return 'rose';

      }


      if (
        title.includes(
          'sterling silver'
        ) ||
        title.includes(
          'silver'
        ) ||
        title.includes(
          '925'
        )
      ) {

        return 'silver';

      }


      return null;

    }


    // ========================================================
    // GET GALLERY
    // ========================================================

    function getGallery() {

      return document.querySelector(
        'media-gallery'
      );

    }


    // ========================================================
    // GET MAIN SLIDES
    // ========================================================

    function getSlides(
      gallery
    ) {

      return Array.from(
        gallery.querySelectorAll(
          '.product__media-item[data-media-id]'
        )
      );

    }


    // ========================================================
    // GET IMAGE ALT
    // ========================================================

    function getAlt(
      slide
    ) {

      const image =
        slide.querySelector(
          'img'
        );


      if (!image) {

        return '';

      }


      return normalize(
        image.getAttribute(
          'alt'
        ) || ''
      );

    }


    // ========================================================
    // GET IMAGE METAL
    // ========================================================

    function getImageMetal(
      slide
    ) {

      const image =
        slide.querySelector(
          'img'
        );


      if (!image) {

        return null;

      }


      const alt =
        normalize(
          image.getAttribute(
            'alt'
          ) || ''
        );


      if (!alt) {

        return null;

      }


      // ======================================================
      // YELLOW GOLD
      // ======================================================

      if (
        alt === 'yellow' ||
        alt.includes(
          'yellow gold'
        ) ||
        alt.includes(
          'yellowgold'
        ) ||
        /\b9k\s+yellow\b/.test(alt) ||
        /\b10k\s+yellow\b/.test(alt) ||
        /\b14k\s+yellow\b/.test(alt) ||
        /\b18k\s+yellow\b/.test(alt)
      ) {

        return 'yellow';

      }


      // ======================================================
      // WHITE GOLD
      // ======================================================

      if (
        alt === 'white' ||
        alt.includes(
          'white gold'
        ) ||
        alt.includes(
          'whitegold'
        ) ||
        /\b9k\s+white\b/.test(alt) ||
        /\b10k\s+white\b/.test(alt) ||
        /\b14k\s+white\b/.test(alt) ||
        /\b18k\s+white\b/.test(alt)
      ) {

        return 'white';

      }


      // ======================================================
      // ROSE GOLD
      // ======================================================

      if (
        alt === 'rose' ||
        alt.includes(
          'rose gold'
        ) ||
        alt.includes(
          'rosegold'
        ) ||
        /\b9k\s+rose\b/.test(alt) ||
        /\b10k\s+rose\b/.test(alt) ||
        /\b14k\s+rose\b/.test(alt) ||
        /\b18k\s+rose\b/.test(alt)
      ) {

        return 'rose';

      }


      // ======================================================
      // SILVER
      // ======================================================

      if (
        alt === 'silver' ||
        alt.includes(
          'silver'
        ) ||
        alt.includes(
          'sterling silver'
        ) ||
        alt.includes(
          '925 silver'
        ) ||
        alt.includes(
          's 925 silver'
        ) ||
        alt.includes(
          's 925 sterling silver'
        ) ||
        alt.includes(
          's 925'
        )
      ) {

        return 'silver';

      }


      // ======================================================
      // STEEL
      // ======================================================

      if (
        alt === 'steel' ||
        alt.includes(
          'steel'
        ) ||
        alt.includes(
          'stainless steel'
        ) ||
        alt.includes(
          'stainless still'
        )
      ) {

        return 'steel';

      }


      return null;

    }


    // ========================================================
    // GET THUMBNAILS
    // ========================================================

    function getThumbnails(
      gallery
    ) {

      const container =
        gallery.querySelector(
          '[id^="GalleryThumbnails"]'
        );


      if (!container) {

        return [];

      }


      return Array.from(
        container.querySelectorAll(
          '[data-target]'
        )
      );

    }


    // ========================================================
    // LOCK GALLERY
    // ========================================================

    function lockGallery() {

      const gallery =
        getGallery();


      if (!gallery) {

        return;

      }


      if (
        typeof gallery.lockVariantGallery ===
        'function'
      ) {

        gallery.lockVariantGallery();

      } else {

        gallery.dataset.variantChanging =
          'true';

      }

    }


    // ========================================================
    // UNLOCK GALLERY
    // ========================================================

    function unlockGallery() {

      const gallery =
        getGallery();


      if (!gallery) {

        return;

      }


      if (
        typeof gallery.unlockVariantGallery ===
        'function'
      ) {

        gallery.unlockVariantGallery();

      } else {

        requestAnimationFrame(
          function () {

            requestAnimationFrame(
              function () {

                delete gallery.dataset.variantChanging;

              }
            );

          }
        );

      }

    }


    // ========================================================
    // REORDER MAIN GALLERY
    // ========================================================

    function reorderSlides(
      gallery,
      slides,
      selectedSlides
    ) {

      if (
        !slides.length ||
        !selectedSlides.length
      ) {

        return;

      }


      const parent =
        slides[0].parentElement;


      if (!parent) {

        return;

      }


      const selectedSet =
        new Set(
          selectedSlides
        );


      const first =
        slides.filter(
          function (slide) {

            return selectedSet.has(
              slide
            );

          }
        );


      const rest =
        slides.filter(
          function (slide) {

            return !selectedSet.has(
              slide
            );

          }
        );


      const finalOrder =
        first.concat(
          rest
        );


      /*
       * IMPORTANT:
       * Only append if position actually
       * needs to change.
       *
       * This avoids unnecessary DOM work.
       */

      const currentOrder =
        Array.from(
          parent.children
        );


      let changed =
        false;


      finalOrder.forEach(
        function (
          slide,
          index
        ) {

          if (
            currentOrder[index] !==
            slide
          ) {

            changed =
              true;

          }

        }
      );


      if (!changed) {

        return;

      }


      finalOrder.forEach(
        function (slide) {

          parent.appendChild(
            slide
          );

        }
      );

    }


    // ========================================================
    // REORDER THUMBNAILS
    // ========================================================

    function reorderThumbnails(
      gallery,
      selectedSlides
    ) {

      const thumbnails =
        getThumbnails(
          gallery
        );


      if (
        !thumbnails.length
      ) {

        return;

      }


      const selectedIds =
        new Set(
          selectedSlides.map(
            function (slide) {

              return String(
                slide.getAttribute(
                  'data-media-id'
                ) || ''
              );

            }
          )
        );


      const selected =
        thumbnails.filter(
          function (thumbnail) {

            return selectedIds.has(
              String(
                thumbnail.getAttribute(
                  'data-target'
                ) || ''
              )
            );

          }
        );


      const rest =
        thumbnails.filter(
          function (thumbnail) {

            return !selectedIds.has(
              String(
                thumbnail.getAttribute(
                  'data-target'
                ) || ''
              )
            );

          }
        );


      const finalOrder =
        selected.concat(
          rest
        );


      const parent =
        thumbnails[0].parentElement;


      if (!parent) {

        return;

      }


      const currentOrder =
        Array.from(
          parent.children
        );


      let changed =
        false;


      finalOrder.forEach(
        function (
          thumbnail,
          index
        ) {

          if (
            currentOrder[index] !==
            thumbnail
          ) {

            changed =
              true;

          }

        }
      );


      if (!changed) {

        return;

      }


      finalOrder.forEach(
        function (thumbnail) {

          parent.appendChild(
            thumbnail
          );

        }
      );

    }


    // ========================================================
    // UPDATE GALLERY
    // ========================================================

    function updateGallery() {

      const variant =
        getSelectedVariant();


      if (!variant) {

        return false;

      }


      const metal =
        getSelectedMetal(
          variant
        );


      if (!metal) {

        console.log(
          '[D2D Gallery] Metal not detected:',
          variant.title
        );

        return false;

      }


      const gallery =
        getGallery();


      if (!gallery) {

        return false;

      }


      const slides =
        getSlides(
          gallery
        );


      if (!slides.length) {

        return false;

      }


      console.log(
        '[D2D Gallery] Selected variant:',
        variant.title
      );


      console.log(
        '[D2D Gallery] Selected metal:',
        metal
      );


      // ======================================================
      // FIND SELECTED METAL IMAGES
      // ======================================================

      const selectedSlides =
        slides.filter(
          function (slide) {

            return (
              getImageMetal(
                slide
              ) === metal
            );

          }
        );


      console.log(
        '[D2D Gallery] Matching images:',
        selectedSlides.length
      );


      if (
        !selectedSlides.length
      ) {

        console.warn(
          '[D2D Gallery] No images found for:',
          metal
        );

        return false;

      }


      // ======================================================
      // REORDER MAIN IMAGES
      // ======================================================

      reorderSlides(
        gallery,
        slides,
        selectedSlides
      );


      // ======================================================
      // REORDER THUMBNAILS
      // ======================================================

      reorderThumbnails(
        gallery,
        selectedSlides
      );


      // ======================================================
      // FIRST SELECTED IMAGE ACTIVE
      //
      // DO NOT call:
      //
      // gallery.setActiveMedia()
      // viewer.resetPages()
      //
      // because these can cause the blink.
      // ======================================================

      const firstSlide =
        selectedSlides[0];


      const currentActive =
        gallery.querySelector(
          '[data-media-id].is-active'
        );


      if (
        currentActive &&
        currentActive !== firstSlide
      ) {

        currentActive.classList.remove(
          'is-active'
        );

      }


      firstSlide.classList.add(
        'is-active'
      );


      // ======================================================
      // ACTIVE THUMBNAIL
      // ======================================================

      const firstMediaId =
        firstSlide.getAttribute(
          'data-media-id'
        );


      if (firstMediaId) {

        const thumbnails =
          getThumbnails(
            gallery
          );


        thumbnails.forEach(
          function (thumbnail) {

            const target =
              thumbnail.getAttribute(
                'data-target'
              );


            const button =
              thumbnail.querySelector(
                'button'
              );


            if (!button) {

              return;

            }


            if (
              String(target) ===
              String(firstMediaId)
            ) {

              button.setAttribute(
                'aria-current',
                true
              );

            } else {

              button.removeAttribute(
                'aria-current'
              );

            }

          }
        );

      }


      return true;

    }


    // ========================================================
    // VARIANT CHANGE LOCK
    //
    // CAPTURE PHASE = TRUE
    //
    // This runs BEFORE Ella's normal
    // change handlers.
    // ========================================================

    document.addEventListener(
      'change',
      function (event) {

        const target =
          event.target;


        if (!target) {

          return;

        }


        /*
         * Only lock for product option
         * controls, not unrelated selects.
         */

        const isOptionControl =
          target.matches(
            'input[type="radio"][name^="option"], ' +
            'input[type="radio"][name*="option"], ' +
            'select[name^="options"], ' +
            'select[name*="option"]'
          );


        if (
          isOptionControl
        ) {

          lockGallery();

        }

      },
      true
    );


    // ========================================================
    // VARIANT ID WATCHER
    // ========================================================

    let lastVariantId =
      String(
        variantInput.value || ''
      );


    let updateTimer =
      null;


    setInterval(
      function () {

        const currentVariantId =
          String(
            variantInput.value || ''
          );


        if (
          !currentVariantId ||
          currentVariantId ===
          lastVariantId
        ) {

          return;

        }


        lastVariantId =
          currentVariantId;


        clearTimeout(
          updateTimer
        );


        /*
         * Give Shopify only enough time
         * to finish changing variant data.
         */

        updateTimer =
          setTimeout(
            function () {

              const success =
                updateGallery();


              if (success) {

                unlockGallery();

              } else {

                /*
                 * If media DOM is still being
                 * updated, retry once.
                 */

                setTimeout(
                  function () {

                    updateGallery();

                    unlockGallery();

                  },
                  150
                );

              }

            },
            100
          );

      },
      100
    );


    // ========================================================
    // SHOPIFY VARIANT EVENT
    // ========================================================

    document.addEventListener(
      'variant:change',
      function () {

        lockGallery();


        clearTimeout(
          updateTimer
        );


        updateTimer =
          setTimeout(
            function () {

              updateGallery();

              unlockGallery();

            },
            100
          );

      }
    );


    // ========================================================
    // OTHER VARIANT CHANGE EVENT
    // ========================================================

    document.addEventListener(
      'variantChange',
      function () {

        lockGallery();


        clearTimeout(
          updateTimer
        );


        updateTimer =
          setTimeout(
            function () {

              updateGallery();

              unlockGallery();

            },
            100
          );

      }
    );


    // ========================================================
    // INITIAL LOAD
    // ========================================================

    setTimeout(
      function () {

        updateGallery();

      },
      150
    );

  }
);

